var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLessonsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 1.3px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.8,7.3c0-.4,0-.6,0-.8,0-.1.2-.2.3-.2.1,0,.3.1.7.3l4.2,2.7c.3.2.5.3.5.4,0,.1,0,.2,0,.3,0,.1-.2.2-.5.4l-4.2,2.7c-.4.2-.5.3-.7.3-.1,0-.2,0-.3-.2,0-.1,0-.3,0-.8v-5.4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2,6.3c0-1.5,0-2.2.3-2.8.3-.5.7-.9,1.2-1.2.6-.3,1.3-.3,2.8-.3h7.5c1.5,0,2.2,0,2.8.3.5.3.9.7,1.2,1.2.3.6.3,1.3.3,2.8v7.5c0,1.5,0,2.2-.3,2.8-.3.5-.7.9-1.2,1.2-.6.3-1.3.3-2.8.3h-7.5c-1.5,0-2.2,0-2.8-.3-.5-.3-.9-.7-1.2-1.2-.3-.6-.3-1.3-.3-2.8v-7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLessonsIcon);
export default __webpack_public_path__ + "static/media/lessons-icon.ddb7c6f482e3f6684ad80daec3c8a1a7.svg";
export { ForwardRef as ReactComponent };